module.exports = __webpack_public_path__ + "img/contact.c0a96ff1.jpg";